import _ from 'lodash';
import { connect } from 'react-redux';
import { compose, lifecycle, withState, withHandlers } from 'recompose';

import Tasks from '../components/Tasks';
import API from '../../../../utils/api';
import { createSocket } from '../../../../utils/socket';
import { ROLES } from 'consts';

const configureSocket = props => {
  const socket = createSocket('tasks');
  socket.on('refreshTasks', () => props.refreshTaskList(props));

  props.setSocket(socket);
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    roles: _.get(state, 'auth.currentGroup.myRoles', 'default'),
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withState('tasks', 'setTasks', []),
  withState('socket', 'setSocket', null),
  withHandlers({
    refreshTaskList: props => () =>
      API.getTasks().then(data => {
        if (data) {
          props.setTasks(data);
        }
      }),
  }),
  withHandlers({
    startTask: () => type => API.startTask({ type }),
    stopTask: () => type => API.stopTask({ type }),
    runTask: () => type => API.runTask({ type }),
  }),
  lifecycle({
    componentDidMount() {
      this.props.refreshTaskList();
      configureSocket(this.props);
    },
    componentWillUnmount() {
      try {
        this.props.socket.close();
      } catch (err) {}
    },
    componentDidUpdate() {
      if (
        !this.props.roles.includes(ROLES.SPORTRADAR) &&
        !this.props.roles.includes(ROLES.SUPERADMIN)
      ) {
        this.props.socket.close();
        this.props.history.push('/dashboard');
      }
    },
  })
);

export default enhance(Tasks);
